// TODO: add confirmation modal when refactoring.